import { Button, Layout, Space, theme } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { Link, useLocation, useParams } from "react-router-dom";
import SidebarBashIcon from "../../../assets/icons/SidebarBashIcon";
import { SidebarLayoutProps } from "../../../layouts/SidebarLayout";
import { getSanitizedPathname } from "../../../utils/utils";
import NotificationMenu from "./NotificationMenu";
import ProfileMenu from "./ProfileMenu";

interface SidebarContentProps extends SidebarLayoutProps {
  collapsed?: boolean;
  handleCollapsed: () => void;
  handleShowSidebar: () => void;
  // data?: GetEmployeeDetailsResponseType;
  // isLoading: boolean;
  contentClass?: string;
}

export interface CheckedData {
  name?: string | null;
  gender?: string | null;
  department_id?: number;
  business_role_id?: number;
  joiningDate?: string | null;
}

export default function SidebarContent({
  handleShowSidebar,
  handleCollapsed,
  children,
  title,
  tabList,
  // data,
  // isLoading,
  contentClass,
}: SidebarContentProps) {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const location = useLocation();
  const params = useParams();

  return (
    <Layout>
      <div>
        <div className={`sticky !bg-white z-50 top-0`}>
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
            }}
            className="h-20 border-b border-extra-light"
          >
            <div className="flex items-center max-h-full justify-between pr-5 h-full">
              <div className="flex items-center h-full">
                <div className="h-full flex justify-center items-center pl-6 pr-3">
                  <Button
                    type="text"
                    icon={<SidebarBashIcon />}
                    onClick={handleShowSidebar}
                    className="lg:hidden flex justify-center items-center"
                    size="small"
                  />
                  <Button
                    type="text"
                    icon={<SidebarBashIcon />}
                    onClick={handleCollapsed}
                    className="hidden lg:flex justify-center items-center"
                    size="small"
                  />
                </div>
                {title && (
                  <h4 className="text-sub-header text-lg sm:text-[22px] font-semibold leading-[33px] mr-3">
                    {title}
                  </h4>
                )}
              </div>

              <div className="flex items-center gap-6">
                <NotificationMenu />
                <ProfileMenu />
              </div>
            </div>
          </Header>
          {tabList?.length ? (
            <Space
              size={16}
              align="center"
              className="w-full h-[46px] px-6 bg-white border-b border-extra-light"
            >
              {tabList.map((tab) => {
                const currentPath = getSanitizedPathname(
                  location.pathname,
                  params
                );

                return (
                  <Link
                    to={tab?.disabled ? "" : tab.link}
                    className={`px-1.5 text-base font-medium inline-block relative after:absolute after:w-full after:left-0 after:-bottom-3 cursor-pointer select-none ${
                      currentPath === tab.link
                        ? "!text-primary after:bg-primary after:h-0.5"
                        : "!text-body-text after:h-0"
                    }`}
                    key={tab.link}
                  >
                    {tab.label}
                  </Link>
                );
              })}
            </Space>
          ) : undefined}
        </div>

        <Content
          className={`p-6 bg-[#fff] min-h-[calc(100vh-5rem)]
            ${contentClass}
          `}
        >
          {children}
        </Content>
      </div>
    </Layout>
  );
}
